var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrecriptionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.325,
    height: 29.25,
    viewBox: "0 0 26.325 29.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#582bb8;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.9,29.25,7.1,27.056,9.29,29.25l2.194-2.194,2.194,2.194,2.194-2.194,2.194,2.194,2.194-2.194,2.194,2.194,2.194-2.194L26.84,29.25l2.194-2.194,2.194,2.194V1.721A1.722,1.722,0,0,0,29.51,0H6.619A1.717,1.717,0,0,0,4.9,1.721ZM26.84,16.088H9.29V13.163H26.84Zm0,5.85H9.29V19.013H26.84ZM13.5,7.742h2.581V6.023H13.5V3.442H11.784V6.023H9.2v1.72h2.58v2.581H13.5Zm6.108,2.151V6.969H26.84V9.894Z",
    transform: "translate(-4.902 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrecriptionsIcon);
export default __webpack_public_path__ + "static/media/precriptions-icon.199c3d71ea23feb21f12af19db402785.svg";
export { ForwardRef as ReactComponent };